var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothPicLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 57,
    viewBox: "0 0 78 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6004 54.1004C72.7004 55.5004 66.2004 56.0004 61.4004 56.1004L38.7004 10.3004H37.4004L14.8004 56.1004C10.0004 56.0004 4.30039 55.5004 -0.599609 54.1004L28.1004 0.400391H48.6004L77.6004 54.1004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6996 40.4004C47.6996 45.7004 43.3996 49.9004 38.0996 49.9004C32.7996 49.9004 28.5996 45.6004 28.5996 40.4004C28.5996 35.1004 32.8996 30.9004 38.0996 30.9004C43.3996 30.9004 47.6996 35.1004 47.6996 40.4004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothPicLight);
export default __webpack_public_path__ + "static/media/ToothPicLight.9e21d8c166fbf17e33e69934a819cb89.svg";
export { ForwardRef as ReactComponent };